export default __webpack_public_path__ + "static/media/aro.cba4da3e.png";